<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="payApply">去查看</el-button>
    </settings-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'

export default {
  name: 'FailLogCard',
  components: {
    SettingsCard
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    payApply() {
      this.$router.push('/notify-fail-logs')
    }
  }
}
</script>
